import { Control, FieldArrayWithId, useWatch } from "react-hook-form";
import { FacilityDraftFormValues, UnitOption } from "../types/facilityDrawer.types";
import AddRecordButton from "./AddRecordButton";
import DistributionTotalFooter from "./DistributionTotalFooter";
import EnergyRecordFields from "./EnergyRecordFields";
import FacilitySectionCard from "./FacilitySectionCard";
import SourceRecordCard from "./SourceRecordCard";
import SourceSectionEmptyHint from "./SourceSectionEmptyHint";

interface EnergySectionProps {
  control: Control<FacilityDraftFormValues>;
  fields: FieldArrayWithId<FacilityDraftFormValues, "energy", "id">[];
  energyOptions: UnitOption[];
  distributionErrors: Record<string, string>;
  onAdd: () => void;
  onRemove: (index: number) => void;
}

const EnergySection = ({
  control,
  fields,
  energyOptions,
  distributionErrors,
  onAdd,
  onRemove
}: EnergySectionProps) => {
  const energyValues = useWatch({ control, name: "energy" }) ?? [];
  const total = energyValues.reduce((sum, row) => sum + (Number(row?.Percentage) || 0), 0);

  return (
    <FacilitySectionCard
      label="Power sources"
      action={<AddRecordButton label="power source" onClick={onAdd} />}
      footer={fields.length > 0 ? <DistributionTotalFooter total={total} /> : undefined}
    >
      {fields.length === 0 && <SourceSectionEmptyHint sectionLabel="Power sources" />}
      <div className="tw-space-y-3">
        {fields.map((field, index) => (
          <SourceRecordCard key={field.id} index={index} onRemove={() => onRemove(index)}>
            <EnergyRecordFields
              control={control}
              index={index}
              energyOptions={energyOptions}
              distributionError={distributionErrors[`energy.${index}.Percentage`]}
            />
          </SourceRecordCard>
        ))}
      </div>
    </FacilitySectionCard>
  );
};

export default EnergySection;
